function menusController($scope, $routeSegment, $uibModal, $timeout, messageService,
                         departmentService, menuService, merchantService,
                         appConfig, gettextCatalog, outletDepartmentData, $log) {

    const vm = this;
    
    vm.sharedMenus = []; // Menus that can be shared but are not currently in use in this outlet
    vm.outletMenus = []; // Menus used in the outlet

    vm.isElevatedUser = appConfig.isElevatedUser;

    vm.loading = true;

    vm.disableExpression = merchantService.behaviour(merchantService.merchantInfo, 'menuPage.disableEditOnOutletLevel');

    vm.showMenuCreate = false;
    vm.isPaymentez = merchantService.behaviour(merchantService.merchantInfo, 'menuPage.paymentez.showMenuSyncButton');
    vm.isEunoia = merchantService.behaviour(merchantService.merchantInfo, 'menuPage.eunoia.showMenuSyncButton');
    vm.syncing = false;
    vm.synced = false;
    vm.syncError = false;
    vm.existingMenuTypes = [];

    const init = function() {
        if (outletDepartmentData.length > 0) {
            vm.departmentId = outletDepartmentData[0].id;
            vm.refreshLists();
        } else {
            vm.loading = false; // No departments
        }
    };

    const setShowMenuButton = function() {
        if (vm.isPaymentez || vm.isEunoia) {
            vm.showMenuCreate = false;
            return;
        }
        vm.showMenuCreate = true;
    };
    const isMenuShared = (menu, menuList) => {
        return menuList.find( item => item.id === menu.id);
    }

    vm.refreshLists = function() {
        vm.loading = true;
        vm.existingMenuTypes = [];
        menuService.loadMenus(vm.departmentId)
            .then(data => {
                vm.outletMenus = data;
                vm.existingMenuTypes = vm.outletMenus.map(item => item.menuType);
        }).catch(reason => messageService.error(reason));

        menuService.loadSharedMenus()
            .then(data => {
                vm.sharedMenus = data
                    .filter(item => item.shared && !isMenuShared(item, vm.outletMenus));
                setShowMenuButton();
                vm.loading = false;
            }).catch(reason => $log.error(reason));
    };

    vm.createMenu = function($event) {
        departmentService.setCurrentDepId(vm.departmentId);

        vm.menuName = '';
        const menuName = '';

        const modalInstance = $uibModal.open({
            template: require('../templates/menu/editMenu.html'),
            controller: 'MenuEditController',
            windowClass: 'modal-huge dragModal',
            backdrop: 'static',
            resolve: {
                menu() {
                    return {
                        name: menuName
                    };
                },
                isNewMenu() {
                    return true;
                },
                isSharedMenu() {
                    return false;
                },
                existingMenuTypes() {
                    return vm.existingMenuTypes;
                }

            }
        });

        modalInstance.result
            .then(newMenu => {
                vm.openMenu($event, newMenu);
            }).catch(reason => $log.error(reason));
    };

    vm.syncMenu = function() {
        const confMsg = gettextCatalog.getString('Are you sure you want to synchronize the menu for this outlet? ' +
            'This will overwrite changes made within MSS to product name, description, price, option sets and images.');

        const title = 'Synchronize Menu';

        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return confMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then(result => {
            vm.syncError = false;
            if (result === 'ok') {
                vm.syncing = true;
                menuService.syncMenu(vm.departmentId).then(rs => {
                    const data = rs.data;
                    if (data && data.field && data.field === 'false') {
                        vm.synced = false;
                        vm.syncing = false;
                        vm.syncError = true;
                        return;
                    }
                    vm.refreshLists();
                    vm.synced = true;
                    vm.syncing = false;
                    $timeout(() => {
                        vm.synced = false;
                    }, 3000);
                });
            }
        }).catch(reason => $log.error(reason));
    };

    vm.editMenu = function(selectedMenu) {
        departmentService.setCurrentDepId(vm.departmentId);

        menuService.loadMenu(selectedMenu.id).then((promise) => {
            menuService.setCurrentMenu(promise);

            const modalInstance = $uibModal.open({
                template: require('../templates/menu/editMenu.html'),
                controller: 'MenuEditController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    menu() {
                        return menuService.getCurrentMenu();
                    },
                    isNewMenu() {
                        return false;
                    },
                    isSharedMenu() {
                        return false;
                    },
                    existingMenuTypes() {
                        return vm.existingMenuTypes;
                    }

                }
            });

            modalInstance.result
                .then(() => vm.refreshLists())
                .catch(reason => $log.error(reason));
        });
    };
    
    vm.disableOrEnableMenu = function(selectedMenu) {
        const menu = angular.copy(selectedMenu);
        const action = selectedMenu.offline ? gettextCatalog.getString('show') : gettextCatalog.getString('hide');

        const extra = selectedMenu.offline ? '' : gettextCatalog.getString('It will no longer be displayed on the phone.');

        const confMsg = gettextCatalog.getString('Are you sure you want to') + ' ' + action + ' \'' + selectedMenu.name + '\'? ' + extra;

        const title = selectedMenu.offline ? gettextCatalog.getString('Show Menu') : gettextCatalog.getString('Hide Menu');

        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return confMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                menu.offline = !menu.offline;
                menuService.updateMenu(menu).then(() => {
                	vm.refreshLists();
                }, () => {
                	vm.refreshLists();
                });
            }
        });
    };

    // Delete the menu
    vm.deleteMenu = function(selectedMenu, departmentId) {
        departmentService.setSelectedDepartmentId(departmentId);

        const confMsg = gettextCatalog.getString('Are you sure you want to delete the menu') + selectedMenu.name + ' '
            + gettextCatalog.getString('from Qkr?');

        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString('Delete Menu');
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return confMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                menuService.deleteMenu(selectedMenu).then(() => {
                    vm.refreshLists();
                }, (reason) => {
                    vm.refreshLists();
                    messageService.error({message: gettextCatalog.getString('Delete failed:') + ' '
                    + reason.data.message});
                });
            }
        });
    };

    vm.openMenu = function($event, menu) {

        const options = {
            menuViewReadonly:  menu.shared || !vm.isElevatedUser,
            allowedCustomizeMenuItems: true,
            allowedCreateMenuItems: false
        };

        const modalInstance = $uibModal.open({
            template: require('../templates/menu/view_menu.html'),
            controller: 'menuController',
            windowClass: 'view-menu',
            animation: false,
            resolve: {
                options() {
                    return options;
                },
                menuId() {
                    return menu.id;
                },
                departmentId() {
                    return vm.departmentId;
                }
            }
        });

        modalInstance.result
            .then(() => reloadRoute());
    };

    vm.addMenu = function(menu) {
        departmentService.setCurrentDepId(vm.departmentId);
        departmentService.addMenuToCurrentDepartment(menu).then(() => {
            vm.refreshLists();
        }, (reason) => {
            messageService.error({message: reason.data.exception});
        });
    };

    vm.removeMenu = function(menu) {
       // DepartmentService.currentDepartmentId = vm.departmentId
        departmentService.setCurrentDepId(vm.departmentId);
        departmentService.removeMenuFromCurrentDepartment(menu).then(() => {
            vm.refreshLists();
        });
    };

    // Menus have been changed - reload just to be sure
    $scope.$on('newMenus', (evt, args) => {
        vm.refreshLists();
    });


    function reloadRoute() {
        $routeSegment.chain[0].reload();
    }
    init();
}
angular
    .module('qkr')
    .controller('menusController', menusController);


// WEBPACK FOOTER //
// ./src/controllers/menus.controller.js